var map = {
	"./en.json": [
		16150,
		5327
	],
	"./es.json": [
		79677,
		9256
	],
	"./fr.json": [
		56485,
		4052
	],
	"./pt.json": [
		95685,
		6692
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13628;
module.exports = webpackAsyncContext;